import { personName } from 'Data/format.js'

export function getTitle(person, treatment_name) {
  return `All Treatment Notes (${personName(person)} - ${treatment_name})`
}
